// import"./mock"
import Vue from "vue";
import App from "./App.vue";
import "./style/global.less";
import router from "./router";
import showMessage from "./utils/showMessage";
import "./eventBus";
Vue.prototype.$showMessage = showMessage;

import store from "./store";
store.dispatch("setting/fetchSetting");

import { server_URL } from "@/urlConfig";
Vue.prototype.$serverURL = server_URL;
// import "./api/banner"
import vLoading from "./directives/loading";
Vue.directive("loading", vLoading);
import vLazy from "./directives/lazy";
Vue.directive("lazy", vLazy);

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
